import { api } from "@/api/client";
import type { ApiItemResponse } from "@/api/types";
import type { PermissionAction, PermissionResource, RoleName } from "@/api/types";

export interface AuthUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: RoleName;
  permissions: { resource: PermissionResource; action: PermissionAction }[];
}

export interface LoginResult {
  user: { id: string; email: string; firstName: string; lastName: string; role: RoleName };
  accessToken: string;
}

export const authApi = {
  async login(email: string, password: string) {
    const { data } = await api.post<ApiItemResponse<LoginResult>>("/auth/login", { email, password });
    return data.data;
  },

  async me() {
    const { data } = await api.get<ApiItemResponse<AuthUser>>("/auth/me");
    return data.data;
  },

  async logout() {
    await api.post("/auth/logout");
  },

  async changePassword(currentPassword: string, newPassword: string) {
    await api.post("/auth/change-password", { currentPassword, newPassword });
  },

  async forgotPassword(email: string) {
    await api.post("/auth/forgot-password", { email });
  },

  async resetPassword(token: string, newPassword: string) {
    await api.post("/auth/reset-password", { token, newPassword });
  },
};
